module.exports = __webpack_public_path__ + "img/DE01076.f775c5eb.png";